// copied and modified from Viewer, see https://github.com/CartoDB/viewer/blob/master/src/components/common/BasemapSelector.js
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBasemap } from "@carto/react-redux";
import {
  POSITRON,
  VOYAGER,
  DARK_MATTER,
  GOOGLE_SATELLITE,
  GOOGLE_ROADMAP,
} from "@carto/react-basemaps";
import { makeStyles, Tooltip, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import positronImg from "assets/basemaps/positron.jpg";
import voyagerImg from "assets/basemaps/voyager.jpg";
import darkMatterImg from "assets/basemaps/dark-matter.jpg";
import googleMapImg from "assets/basemaps/google-map.jpg";
import googleSatelliteImg from "assets/basemaps/google-satellite.jpg";

const useStyles = makeStyles((theme) => ({
  basemapSelectorContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "&:not(.is-open) $basemapSelector": {
      opacity: 0,
      position: "relative",
      width: theme.spacing(7),
      height: theme.spacing(7),
      marginTop: theme.spacing(-7),
      borderColor: theme.palette.common.white,
      zIndex: 1,
    },
    "&:not(.is-open) $basemapSelector.is-selected": {
      opacity: 1,
    },
    "&.is-open $basemapSelector.is-selected": {
      borderColor: theme.palette.primary.main,
    },
    "&.is-open $basemapSelector": {
      marginTop: theme.spacing(2),
      pointerEvents: "all",
    },
    "&.is-open $basemapMain": {
      opacity: 1,
    },
  },
  basemapSelector: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    borderRadius: "50%",
    marginTop: theme.spacing(-6),
    overflow: "hidden",
    border: "2px solid rgba(44,48,50,0.12)",
    transition: "all 0.2s cubic-bezier(.4,.01,.165,.99)",
    pointerEvents: "none",
    zIndex: 0,
    boxShadow:
      "0 1px 1px 0 rgba(0,0,0,0.08), 0 2px 1px -1px rgba(0,0,0,0.04), 0 1px 3px 0 rgba(0,0,0,0.16)",
    cursor: "pointer",
    "& img": {
      height: "100%",
    },
  },
  basemapMain: {
    opacity: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: theme.spacing(7),
    height: theme.spacing(7),
    borderRadius: 50,
    backgroundColor: theme.palette.common.black,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.common.black,
    },
    "& span": {
      margin: 0,
    },
    "& svg": {
      fill: "#fff",
    },
  },
}));

const BASEMAPS_CONFIG = [
  {
    basemap: POSITRON,
    label: "Positron",
    img: positronImg,
  },
  {
    basemap: VOYAGER,
    label: "Voyager",
    img: voyagerImg,
  },
  {
    basemap: DARK_MATTER,
    label: "Dark Matter",
    img: darkMatterImg,
  },
  {
    basemap: GOOGLE_ROADMAP,
    label: "Google Maps",
    img: googleMapImg,
  },
  {
    basemap: GOOGLE_SATELLITE,
    label: "Google Satellite",
    img: googleSatelliteImg,
  },
];

export default function BasemapWidget({ className = "" }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const basemap = useSelector((state) => state.carto.basemap);
  const [selectorsOpen, setSelectorsOpen] = useState(false);

  function handleBasemap(newBasemap) {
    dispatch(setBasemap(newBasemap));
    setSelectorsOpen(false);
  }

  function handleSelectorVisibility() {
    setSelectorsOpen((prev) => !prev);
  }

  return (
    <div
      className={`${className} ${classes.basemapSelectorContainer} ${
        selectorsOpen ? "is-open" : ""
      }`}
    >
      <IconButton
        className={classes.basemapMain}
        onClick={handleSelectorVisibility}
      >
        <CloseIcon />
      </IconButton>
      {BASEMAPS_CONFIG.map((b) => (
        <IconButton
          key={b.label}
          className={`${classes.basemapSelector} ${
            basemap === b.basemap ? "is-selected" : ""
          }`}
          onClick={() => handleBasemap(b.basemap)}
        >
          <Tooltip placement="left" title={`CARTO ${b.label}`} arrow>
            <img src={b.img} alt={`${b.label} basemap`} />
          </Tooltip>
        </IconButton>
      ))}
    </div>
  );
}
